export const COOKIE_CONSENT_OPEN_EVENT = 'cookie-consent:open';

/** Rouvre le bandeau de consentement cookies depuis n'importe quel composant. */
export function openCookieConsent() {
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_OPEN_EVENT));
}
